<div class="wrapper mx-auto mt-3" style="max-width: 700px; width: 100%;">
  <div class="container">
    <div class="row news-card py-3 border bg-white rounded">
      <!-- Left Side: Image (For Large Screens) -->
      <div class="col-lg-5 d-none d-lg-block">
        <div class="ratio ratio-1x1">
          <img loading="lazy" [src]="data?.data?.image" class="news-image img-fluid rounded" alt="News Image"
            (click)="openModal(data?.data?.image)" >
        </div>
      </div>

      <!-- Right Side: Content -->
      <div class="col-lg-7 col-12">
        <!-- Author & Profile Section -->
        <div class="d-flex align-items-center mb-3">
          <!-- Profile Image (Click to Open Modal) -->
          <img loading="lazy" [src]="data?.data?.Owner?.profilePicture"
            class="profile-img me-3 img-fluid rounded-circle object-fit-cover"
            style="height: 70px; width: 70px; border-radius: 50%;" alt="Profile Image"
            (click)="openModal(data?.data?.Owner?.profilePicture)" >

          <div class="d-flex flex-column">
            <button (click)="redirectToCitizenProfile()" class="btn px-2">
              <div class="fw-bold text-primary">
                {{ data?.data?.Owner?.name }}
              </div>
            </button>
            <span class="text-warning fw-semibold small mb-0 ms-2">{{ data?.data?.Owner?.type === 'User' ? 'Citizen' : data?.data?.Owner?.type  }}</span>
            <span class="text-muted small mb-0 ms-2 "><i class="bi bi-calendar"></i>&nbsp;&nbsp;{{ data?.data?.created |
              date }}</span>
          </div>

          <!-- Status Button (Left) -->
          <button class="btn bg-primary rounded ms-auto share-btn me-2" (click)="toggleButtonClick('status')">
            <i *ngIf="data?.data?.status === 'New'" class="bi bi-plus-circle"></i>
            <i *ngIf="data?.data?.status !== 'New'" class="bi bi-check-circle"></i>&nbsp;&nbsp;<span>{{ data?.data?.status
              }}</span>
          </button>
        </div>

        <!-- Image (For Mobile) -->
        <div class="d-lg-none text-center mb-3">
          <div class="ratio ratio-4x3">
            <img loading="lazy" [src]="data?.data?.image" class="news-image img-fluid rounded" alt="News Image"
              (click)="openModal(data?.data?.image)" data-bs-toggle="modal" data-bs-target="#imageModal">
          </div>

        </div>

        <!-- News Title -->
        <h5 style="white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: 1.5;
        line-clamp: 1;" (click)="redirectToSingleIssue()">
          {{ data?.data?.title }}
        </h5>



        <!-- Description -->
        <p class="text-muted" style="white-space: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-clamp: 3;" (click)="redirectToSingleIssue()">{{ data?.data?.origionalItem?.description }}</p>

        <!-- Tags -->
        <div class="tagsClass">

          <span class="me-2">
            <i class="bi bi-list" *ngIf="data?.data?.category"></i> {{ data?.data?.category }}
          </span>
          <span class="me-2">
            <i class="bi bi-tag" *ngIf="data?.data?.type"></i> {{ data?.data?.type }}
          </span>
          <span class="me-2">
            <i class="bi bi-geo-alt" *ngIf="data?.data?.Owner?.address?.location"></i> {{
            data?.data?.Owner?.address?.location }}
          </span>
        </div>

        <div class="d-flex align-items-center mb-2 mt-1">
          <button class="btn btn-sm" (click)="toggleButtonClick('like')">
            <i class="bi text-success" [ngClass]="{'bi-hand-thumbs-up-fill': isLiked, 'bi-hand-thumbs-up': !isLiked}"></i>
            &nbsp;<span>{{ data?.data?.LikeDislikeSummary?.likes}}</span>
          </button>
          <button class="btn btn-sm" (click)="toggleButtonClick('dislike')">
            <i class="bi text-danger" [ngClass]="{'bi-hand-thumbs-down-fill': isDisliked, 'bi-hand-thumbs-down': !isDisliked}"></i>
            &nbsp;<span>{{ data?.data?.LikeDislikeSummary?.dislikes}}</span>
          </button>
          <div class="ms-auto">
          <button class="btn btn-sm" (click)="openCommentModal($event)">
            <!-- <i class="bi bi-chat fs-6 me-1"></i> -->
            <comment-component *ngIf="commentData" [data]="commentData"></comment-component>
            <span>{{data?.data?.ratings?.comments}}</span>
          </button>          
          <!-- Share Button (Right) -->
          <button class="btn btn-sm" (click)="onShareClick($event)">
            <i class="bi bi-share"></i>
            <span *ngIf="!config?.useIcons">{{ data?.data?.share }}</span>
          </button>
        </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal for Image -->
  <div class="modal fade" id="imageModal" tabindex="-1" aria-labelledby="imageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ data?.data?.Owner?.name }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body text-center" *ngIf="selectedImage !==''">
          <img [src]="selectedImage" class="img-fluid rounded" alt="Selected Image">
        </div>
      </div>
    </div>
  </div>
</div>